import { watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from '@/composable/message-dialog';

/**
 * 履歴アイテムへのスクロール処理を管理するコンポーザブル
 */
export function useScrollToHistoryItem() {
  const { alert } = useAlert();
  const { t } = useI18n();

  /**
   * 指定されたUUIDの履歴アイテムにスクロールする
   * @param uuid - スクロール対象の履歴アイテムのUUID
   * @param getHistoryItems - 履歴アイテムを取得する関数
   * @param getHistoryLoading - 履歴ローディング状態を取得する関数
   */
  const scrollToHistoryItem = (
    uuid: string,
    getHistoryItems: () => HTMLElement[],
    getHistoryLoading: () => boolean,
  ) => {
    const unwatch = watch([getHistoryLoading, getHistoryItems], async ([loading, historyItems]) => {
      if (loading) return;

      await nextTick();
      // NOTE: 描画完了を待つ＆元からhistoryItemsが1件もない時は処理をしない
      if (historyItems.length === 0) return;

      const historyItem = historyItems?.find(
        ref => ref.dataset.uuid === uuid,
      );
      
      if (historyItem == null) {
        await alert({
          title: t('general.error'),
          message: t('history.uuidUndefined'),
        });
        return;
      }
      
      historyItem.scrollIntoView({ behavior: 'smooth' });
      unwatch();
    },
    {
      flush: 'post',
    });

    return unwatch;
  };

  return {
    scrollToHistoryItem,
  };
}
